import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import DeploymentUpdatePrompt from "./DeploymentUpdatePrompt";
import VendorMasterQaHarness from "./vendor-master/VendorMasterQaHarness";
import PaymentDepositQaHarness from "./payment-deposit/PaymentDepositQaHarness";
import AdminDashboardQaHarness from "./admin-dashboard/AdminDashboardQaHarness";
import ErpBridgeQaHarness from "./erp-bridge/ErpBridgeQaHarness";
import "./index.css";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);
const showVendorMasterQa =
  process.env.NODE_ENV !== "production" &&
  window.location.pathname === "/vendor-master-qa";
const showPaymentDepositQa =
  process.env.NODE_ENV !== "production" &&
  window.location.pathname === "/payment-deposit-qa";
const showAdminDashboardQa =
  process.env.NODE_ENV !== "production" &&
  window.location.pathname === "/admin-dashboard-qa";
const showErpBridgeQa =
  process.env.NODE_ENV !== "production" &&
  (window.location.pathname === "/erp-bridge-qa" ||
    new URLSearchParams(window.location.search).get("qa") === "erp-bridge");
const showQaHarness =
  showVendorMasterQa ||
  showPaymentDepositQa ||
  showAdminDashboardQa ||
  showErpBridgeQa;

root.render(
  <React.StrictMode>
    {showVendorMasterQa ? (
      <VendorMasterQaHarness />
    ) : showPaymentDepositQa ? (
      <PaymentDepositQaHarness />
    ) : showAdminDashboardQa ? (
      <AdminDashboardQaHarness />
    ) : showErpBridgeQa ? (
      <ErpBridgeQaHarness />
    ) : (
      <App />
    )}
    {!showQaHarness && <DeploymentUpdatePrompt />}
  </React.StrictMode>
);
